import { inject, injectable } from 'inversify';
import "reflect-metadata";
import { TYPES } from '../di/types';
import IAppConfig from '../config';
import Axios, { AxiosResponse } from "axios";
import { ConnectedApp, ForeignDossier, ForeignInvoice, ForeignInvoiceSearchModel, PagedData, PagedRequest, SearchModel } from './dossierApiClient';

export interface IUserApiClient {
    sendMagicLink(dto: MagicLinkModel): Promise<AxiosResponse>
    login(dto: LoginModel): Promise<AxiosResponse>
    createUser(dto: CreateUserDto): Promise<AxiosResponse>
    getUsers(dto: PagedRequest<SearchModel>): Promise<AxiosResponse<PagedData<UserDto>>>
    getAuthenticateUrl(app: ConnectedApp): Promise<AxiosResponse<string>>;
    getUser(): Promise<AxiosResponse<UserDetailDto>>;
    getCompanies(dto: PagedRequest<SearchModel>): Promise<AxiosResponse<PagedData<ForeignCompany>>>;
    getInvoices(dto: PagedRequest<ForeignInvoiceSearchModel>): Promise<AxiosResponse<PagedData<ForeignInvoice>>>
    getForeignDossiers(dto: PagedRequest<SearchModel>): Promise<AxiosResponse<PagedData<ForeignDossier>>>
    fetchAddresses(): Promise<AxiosResponse<UserAdressDto[]>>
    updateUserAdress(dto: UpdateAddressDto): Promise<AxiosResponse<string>>
    createUserAddress(dto: CreateAddressDto): Promise<AxiosResponse<string>>
}
@injectable()
export class UserApiClient implements IUserApiClient {

    @inject(TYPES.IAppConfig) private _config: IAppConfig;

    getAuthenticateUrl(app: ConnectedApp): Promise<AxiosResponse<string>> {
        return Axios.get(`${this._config.endpointUrl}api/users/getAuthenticateUrl?app=${app}`);
    }
    sendMagicLink(dto: MagicLinkModel): Promise<AxiosResponse> {
        return Axios.post(`${this._config.endpointUrl}api/users/SendMagicLink`, dto);
    }
    login(dto: LoginModel): Promise<AxiosResponse> {
        return Axios.post(`${this._config.endpointUrl}api/users/Login`, dto);
    }
    createUser(dto: CreateUserDto): Promise<AxiosResponse> {
        return Axios.post(`${this._config.endpointUrl}api/users/CreateUser`, dto);
    }
    getUsers(dto: PagedRequest<SearchModel>): Promise<AxiosResponse> {
        return Axios.post(`${this._config.endpointUrl}api/users/GetUsers`, dto)
    }
    getUser(): Promise<AxiosResponse<UserDetailDto>> {
        return Axios.get(`${this._config.endpointUrl}api/users/GetMe`)
    }
    getCompanies(dto: PagedRequest<SearchModel>): Promise<AxiosResponse<PagedData<ForeignCompany>>> {
        return Axios.post(`${this._config.endpointUrl}api/users/GetForeignCompanies`, dto)
    }
    getInvoices(dto: PagedRequest<ForeignInvoiceSearchModel>): Promise<AxiosResponse<PagedData<ForeignInvoice>>> {
        return Axios.post(`${this._config.endpointUrl}api/users/GetForeignInvoices`, dto)
    }
    getForeignDossiers(dto: PagedRequest<SearchModel>): Promise<AxiosResponse<PagedData<ForeignDossier>>> {
        return Axios.post(`${this._config.endpointUrl}api/users/GetForeignDossier`, dto)
    }
    fetchAddresses(): Promise<AxiosResponse<UserAdressDto[]>> {
        return Axios.get(`${this._config.endpointUrl}api/users/FetchAddresses`);
    }
    updateUserAdress(dto: UpdateAddressDto): Promise<AxiosResponse<string>> {
        return Axios.post(`${this._config.endpointUrl}api/users/updateUserAdress`, dto);
    }
    createUserAddress(dto: CreateAddressDto): Promise<AxiosResponse<string>> {
        return Axios.post(`${this._config.endpointUrl}api/users/CreateUserAddress`, dto);
    }
}
export interface UpdateAddressDto {
    id: number;
    companyName: string;
    address: string;
    postalCode: string;
    city: string;
    houseNr: string;
    vatCode: string;
}

export interface CreateAddressDto {
    companyName: string;
    address: string;
    postalCode: string;
    city: string;
    houseNr: string;
    vatCode: string;
}

export interface UserAdressDto {
    id: number;
    companyName: string;
    city: string;
    houseNr: string;
    vatCode: string;
    userId: number;
}
export interface ForeignCompany {
    id: string;
    name: string;
    country: string;
    email: string;
    vat: string;
    address: string;
    city: string;
    postalcode: string;
    houseNr: string;
    type : string
}
export interface MagicLinkModel {
    email: string;
}

export interface LoginModel {
    passwordLink: string;
}
export interface CreateUserDto {
    email: string;
    firstName: string;
    lastName: string;
    address: string;
    postalCode: string;
    city: string;
    houseNr: string;
    vatCode: string;
    companyName: string
}

export interface UserDto {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
}
export interface UserDetailDto {
    email: string;
    firstName: string;
    lastName: string;
    installedOctopus: boolean;
    installedTeamleader: boolean;
    installedExactonline : boolean;
    installationOctopusValid: boolean;
    installationTeamleaderValid: boolean;
    installationExactonlineValid : boolean;
}